"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const button_1 = __importDefault(require("../button"));
const constants_1 = require("../../utils/constants");
const urlSelector_style_1 = __importDefault(require("./urlSelector.style"));
class UrlSelector extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onKeyUp = event => {
            const { onExit, onValidate } = this.props;
            if (event.keyCode === constants_1.escapeKeyCode) {
                onExit();
            }
            else if (event.keyCode === constants_1.enterKeyCode && event.target.value !== '') {
                onValidate(event);
            }
        };
        this.selectAll = event => {
            event.target.select();
        };
        this.render = () => {
            const { classes, onChange, onValidate, url, urlPlaceholder, saveLabel } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.container }, { children: [jsx_runtime_1.jsx("input", { className: classes.url, type: "text", placeholder: urlPlaceholder, value: url, onChange: onChange, onKeyUp: this.onKeyUp, onFocus: this.selectAll, autoFocus: true }, void 0),
                    jsx_runtime_1.jsx(button_1.default, Object.assign({ classes: classes, className: classes.saveBtn, onClick: onValidate, disabled: !url }, { children: saveLabel }), void 0)] }), void 0));
        };
    }
}
exports.UrlSelector = UrlSelector;
UrlSelector.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onValidate: prop_types_1.default.func.isRequired,
    onChange: prop_types_1.default.func,
    onExit: prop_types_1.default.func,
    url: prop_types_1.default.string.isRequired,
    urlPlaceholder: prop_types_1.default.string,
    saveLabel: prop_types_1.default.node
};
UrlSelector.defaultProps = {
    onChange: () => { },
    onExit: () => { },
    urlPlaceholder: 'url',
    saveLabel: 'save'
};
exports.default = react_jss_1.default(urlSelector_style_1.default)(UrlSelector);
//# sourceMappingURL=index.js.map